import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CarbonOperation } from 'src/app/shared/interfaces/carbon-operation';

import { ACX_CUSTODY_WITHDRAWAL_INFO_MESSAGE } from '../shared/operation-custody-withdrawal-details.utils';

@Component({
  standalone: false,
  selector: 'app-operation-custody-withdrawal-details-drawer',
  templateUrl: './operation-custody-withdrawal-details-drawer.component.html',
  styleUrls: ['./operation-custody-withdrawal-details-drawer.component.scss'],
})
export class OperationCustodyWithdrawalDetailsDrawerComponent {
  @Input() open = false;
  @Input() operation: CarbonOperation | null = null;
  @Output() openChange = new EventEmitter<boolean>();

  readonly infoMessage = ACX_CUSTODY_WITHDRAWAL_INFO_MESSAGE;

  close(): void {
    this.open = false;
    this.openChange.emit(false);
  }
}
